// Shared starting values for the Plan workspace and Julio's deterministic
// optimizer. These are editable modeling assumptions, not statutory limits.
export const NEW_COMP_MODELING_DEFAULTS = Object.freeze({
  budgetDollars: 100_000,
  nonTargetHceProfitSharingPercent: 2,
  maxStaffProfitSharingPercent: 25,
  ownerFundingYears: 5,
  ownerProfitSharingPercent: 5,
  nonTargetHceCashBalancePercent: 5,
  staffCashBalancePercent: 2,
  maxStaffCashBalancePercent: 5,
  maxComboStaffProfitSharingPercent: 15,
  projectionYears: 10,
  marginalTaxRatePercent: 37,
  salaryGrowthPercent: 0,
  cashBalanceInterestCreditRate: 0.05,
})

export const MODELING_INPUT_LIMITS = Object.freeze({
  maxOwnerFundingYears: 15,
  maxProjectionYears: 30,
  maxMarginalTaxRatePercent: 60,
  maxSalaryGrowthPercent: 15,
})

export const SCENARIO_SEARCH_LIMITS = Object.freeze({
  maxEvaluations: 600,
  maxMinimumParticipationEvaluations: 400,
})
